module.exports = __webpack_public_path__ + "img/SketchPng9fa123d0abe332a96e6e2df6e056a6e78e04d53e18657b4ef81c9c219b9d07d0.02e1c191.png";